import { VIDEOS_LOADING, VIDEOS_SUCCESS, VIDEOS_FAILURE } from "redux/types";

const initialState = {
  videosLoading: false,
  videos: null,
  errors: null,
};

export const videosReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case VIDEOS_LOADING:
      return { ...state, videosLoading: action.payload };
    case VIDEOS_SUCCESS:
      return { ...state, videos: action.payload };
    case VIDEOS_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
